
import { httpss } from "../utils/host";
export const createRoute = `${httpss}/apis_v1/userEvent/create`;
export const creeateMyuRoute = `${httpss}/apis_v1/userEvent/createUserMyu`;
export const createPhoneRoute = `${httpss}/apis_v1/userEvent/createUserPhone`;
export const getRoute = `${httpss}/apis_v1/userEvent/getUserEvent`;
export const getPhoneRoute = `${httpss}/apis_v1/userEvent/getUserByPhone`;
export const checkIsCaptain = `${httpss}/apis_v1/userEvent/checkIsCaptain`;
export const checkIsAdmin = `${httpss}/apis_v1/userEvent/checkIsAdmin`;
export const updateTeam = `${httpss}/apis_v1/userEvent/updateTeam`;